
import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

const SteadySidebar = () => {



    return(


<Box sx={{ width:"100vw", position:"absolute", left:"0px", top:"0px"}} >
      <AppBar position="static" style={{backgroundColor:"white"}}>
        <Toolbar>
          <Box
            component="img"
            sx={{
              height: 40,
              objectFit: "contain",
              display: { xs: "block", sm: "block" }, // Responsive behavior
              position:"absolute",
              right:20,
              // paddingRight:"10px"
            }}
            alt="Logo"
            src="bjsLogoWhiteBG.png"
          />
          </Toolbar>
          
          </AppBar>
      </Box>




    )
}

export default SteadySidebar;
